// Role hierarchy:
// Staff -> Manager -> Head -> CXO -> Director -> Admin

const ALL_ROLES = ["Staff", "Manager", "Head", "CXO", "Director", "Admin"];

export function canCreateTask(role) {
  // All roles can create tasks
  return ALL_ROLES.includes(role);
}

export function canCreateMom(role) {
  // All roles can create MOMs
  return ALL_ROLES.includes(role);
}

export function canManageUsers(role) {
  // Only Admin manages users
  return role === "Admin";
}

export function isStaff(role) {
  return role === "Staff";
}

export function canSeeAudit(role) {
  // All roles can view the audit log — scoped by the backend to their hierarchy
  return ALL_ROLES.includes(role);
}

export function canValidateTasks(role) {
  // Staff cannot validate/close tasks
  return ["Manager", "Head", "CXO", "Director", "Admin"].includes(role);
}

export function canManageSettings(role) {
  // Only Admin manages settings
  return role === "Admin";
}

export function canReviewTimeline(role) {
  // Staff cannot review timeline requests
  return ["Manager", "Head", "CXO", "Director", "Admin"].includes(role);
}

export function canBulkUpload(role) {
  // Staff cannot bulk upload; all other roles can
  return ["Manager", "Head", "CXO", "Director", "Admin"].includes(role);
}

// ── CRM-specific RBAC ────────────────────────────────────────────────────────

// Only managers+ can mark a deal Won or Lost (protects revenue reporting integrity)
export function canCloseDeal(role) {
  return ["Manager", "Head", "CXO", "Director", "Admin"].includes(role);
}

// Only managers+ can reassign a deal to another owner (affects quotas/targets)
export function canReassignDeal(role) {
  return ["Manager", "Head", "CXO", "Director", "Admin"].includes(role);
}

// Only Admin can permanently delete a CRM deal
export function canDeleteCrmDeal(role) {
  return role === "Admin";
}
